const initAboutProductShowcase = (section) => {
  if (section.dataset.showcaseInitialized === 'true') return;

  const items = Array.from(
    section.querySelectorAll('[data-about-product-showcase-item]')
  );
  const container = section.querySelector('.about-product-showcase__container');
  const desktopQuery = window.matchMedia(
    '(min-width: 1024px) and (min-height: 700px)'
  );
  const reducedMotionQuery = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );
  let activeIndex = -1;
  let frameId = null;
  let enabled = false;

  if (items.length < 2 || !container) return;

  const setItemFocusability = (item, isActive) => {
    item
      .querySelectorAll('a, button, input, select, textarea')
      .forEach((el) => {
        if (isActive) {
          if (el.dataset.showcaseTabindex !== undefined) {
            const previousTabindex = el.dataset.showcaseTabindex;

            if (previousTabindex) el.setAttribute('tabindex', previousTabindex);
            else el.removeAttribute('tabindex');

            delete el.dataset.showcaseTabindex;
          }
          return;
        }

        if (el.dataset.showcaseTabindex === undefined) {
          el.dataset.showcaseTabindex = el.getAttribute('tabindex') || '';
        }
        el.setAttribute('tabindex', '-1');
      });
  };

  const setActiveItem = (nextIndex) => {
    if (nextIndex === activeIndex) return;

    items.forEach((item, index) => {
      const isActive = index === nextIndex;

      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      setItemFocusability(item, isActive);
    });

    activeIndex = nextIndex;
  };

  const update = () => {
    frameId = null;
    if (!enabled) return;

    const rect = section.getBoundingClientRect();
    const scrollDistance = Math.max(
      section.offsetHeight - window.innerHeight,
      1
    );
    const progress = Math.min(Math.max(-rect.top / scrollDistance, 0), 1);
    const nextIndex = Math.min(
      Math.floor(progress * items.length),
      items.length - 1
    );

    setActiveItem(nextIndex);
  };

  const requestUpdate = () => {
    if (frameId === null) frameId = window.requestAnimationFrame(update);
  };

  const setEnabledState = () => {
    const shouldEnable = desktopQuery.matches && !reducedMotionQuery.matches;

    if (shouldEnable === enabled) return;

    enabled = shouldEnable;
    section.classList.toggle('is-scroll-showcase', enabled);
    container.style.minHeight = enabled ? `${items.length * 100}vh` : '';

    if (enabled) {
      setActiveItem(0);
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      requestUpdate();
      return;
    }

    window.removeEventListener('scroll', requestUpdate);
    window.removeEventListener('resize', requestUpdate);

    if (frameId !== null) {
      window.cancelAnimationFrame(frameId);
      frameId = null;
    }

    items.forEach((item) => {
      item.classList.remove('is-active');
      item.removeAttribute('aria-hidden');
      setItemFocusability(item, true);
    });
    activeIndex = -1;
  };

  if (typeof desktopQuery.addEventListener === 'function') {
    desktopQuery.addEventListener('change', setEnabledState);
    reducedMotionQuery.addEventListener('change', setEnabledState);
  } else {
    desktopQuery.addListener(setEnabledState);
    reducedMotionQuery.addListener(setEnabledState);
  }
  setEnabledState();
  section.dataset.showcaseInitialized = 'true';
};

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-about-product-showcase]')
    .forEach(initAboutProductShowcase);
});
